import { AuthorizationStorage } from 'frontcore/domain/authorization/model/AuthorizationService.d'
import {
  PasswordUpdateAPIClient,
  PasswordUpdateAPIClientPayload,
  PasswordUpdateUseCase,
} from 'frontcore/domain/authorization/model/usePasswordUpdate.d'
import { ref, Ref } from 'vue'

export class PasswordUpdateError extends Error { }

const usePasswordUpdate = (
  authorizationStorage: AuthorizationStorage,
  updatePasswordAPIClient: PasswordUpdateAPIClient
): PasswordUpdateUseCase => {
  const error: Ref<string | null> = ref(null)
  const loading = ref(false)

  const update = async (payload: PasswordUpdateAPIClientPayload): Promise<void> => {
    loading.value = true
    try {
      await updatePasswordAPIClient.update(payload)
      if (!payload.user) {
        authorizationStorage.clear()
      }
      error.value = null
    } catch (e) {
      if (e instanceof Error) {
        error.value = e.message
        return
      }
      throw e
    } finally {
      loading.value = false
    }
  }

  return {
    error,
    loading,
    update,
  }
}

export default usePasswordUpdate
